jQuery.noConflict();     
jQuery(document).ready(function($){

	$('#billboard') 
	.before('<span id="billboardPrev">Previous</span> <span id="billboardNext">Next</span>') 
	.cycle({ 
	    fx: 'fade', 
	    speed: 1000, 
	    timeout: 6000,
		pause: true,
		prev: '#billboardPrev',
		next: '#billboardNext',
		pauseOnPagerHover: true,
		slideExpr: '.slide',
		cleartype: true,
		cleartypeNoBg: true
	});
});